import TypeWrapper from "../../utils/TypeWrapper";

const authStyles = {
  root: {
    display: "flex",
    minHeight: "100vh",
    alignItems: "center",
    backgroundSize: "cover",
    justifyContent: "center",
    backgroundPosition: "center",
  },
  paper: {
    width: "100%",
    display: "flex",
    maxWidth: "1100px",
    overflow: "hidden",
    borderRadius: "8px",
    margin: { xs: 4, sm: 4 },
    // padding: { xs: 2, sm: 3 },
    backgroundColor: "transparent",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
  },
  leftSection: {
    flex: 1,
    padding: 4,
    alignItems: "center",
    paddingRight: "20px",
    flexDirection: "column",
    justifyContent: "center",
    borderRight: "1px solid #ccc",
    display: { xs: "none", md: "flex" },
    backgroundColor: TypeWrapper.COLORS.HX_WHITE,
  },
  logo: {
    mb: 3,
    width: "90%",
    height: "auto",
    borderRadius: "8px",
  },
  title: {
    mb: 1,
    fontWeight: "bold",
    fontFamily: "Poppins, serif",
    color: TypeWrapper.COLORS.TITLE,
  },
  SubTitle: {
    fontWeight: "400",
    fontFamily: "Poppins, serif",
    color: TypeWrapper.COLORS.TITLE,
    textAlign: "justify",
  },
  description: {
    mb: 1,
    maxWidth: 500,
    fontWeight: 400,
    textAlign: "justify",
    fontSize: "0.95rem",
    fontFamily: "Poppins, serif",
    color: TypeWrapper.COLORS.SB_TITLE,
  },
  socialIconsContainer: {
    p: 1,
    mb: 3,
    width: "200px",
    display: "flex",
    justifyContent: "space-between",
  },
  socialIcon: {
    padding: 0.8,
    cursor: "pointer",
    borderRadius: "100%",
    transition: "all 0.3s ease",
    border: "1.5px solid #47c69c",
    color: TypeWrapper.COLORS.AUTH_HEADING,
    "&:hover": {
      color: TypeWrapper.COLORS.ORANGE,
      transform: "scale(1.2)",
      border: "1.5px solid orange",
    },
  },
  footerLinks: {
    width: "100%",
    display: "flex",
    maxWidth: "250px",
    justifyContent: "space-between",
  },
  footerText: {
    mt: 2,
    fontWeight: 400,
    fontFamily: "'Poppins', serif",
    color: TypeWrapper.COLORS.FOOTER,
  },
  rightSection: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    padding: { xs: 2, sm: 3 },
    // backgroundColor: "#1c1c1e",
    backgroundColor: TypeWrapper.COLORS.HX_WHITE,
  },
  link: {
    textDecoration: "none",
    fontFamily: "'Poppins', serif",
    color: TypeWrapper.COLORS.SB_TITLE,
    "&:hover": { textDecoration: "underline" },
  },
};

export default authStyles;
